export default "__VITE_ASSET__DZ2ZP$Qe__"